import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    getCurrentUser,
    getDefaultOptionByValue,
    getDOYOptions,
    getMainInstallation,
    getStockholderPositions,
    isEmpty,
    isValidEmail,
    recalculateStockHolders,
    getInstallationsTypes,
    validateAFM
} from "../../../_helpers/commonFunctions";
import {Row, Col, Button, Badge, Modal, Spinner} from "react-bootstrap";
import {toast} from "react-toastify";
import axios from "axios";
import Input from "../../common/Input";
import {setSaveNewCompany} from "../../../_reducers/activitySlice";
import {
    resetNewInstallations,
    setNewInstallations,
    setNewCompany,
    setNewContactPoint,
    resetNewCompany,
    setSelectedUser,
    resetSelectedUser,
    setSearchTerm,
    setCompany,
    setActiveModal
} from "../../../_reducers/companySlice";
import EditableTable from "../../primer/Editable-Table";
import {isValueAlreadyExists} from "../../../_helpers/helperFunctions";
import DateBox from "../../primer/DateBox";
import moment from "moment";
import Dropdown from "../../primer/Dropdown";
import {fetchPrimerMyDataCredentials} from "../../../_apis/api";
import BetterCheckBox from "../../common/BetterCheckBox";
import {MdDelete} from "react-icons/md";
import {useTranslation} from "../../../hooks/useTranslation";

const apiURL2 = process.env.REACT_APP_API_URL2;

const ManageCompanies = () => {
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const COMPANY_DATA = useSelector((state) => state.COMPANY_DATA);
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const currentUser = getCurrentUser();
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const [companyPublicTemplatesList, setCompanyPublicTemplatesList] = useState([]);
    const [companyUsers, setCompanyUsers] = useState([]);
    const [showNewModal, setShowNewModal] = useState(false);
    const [showUsersModal, setShowUsersModal] = useState(false);
    const [companySaveLoader, setCompanySaveLoader] = useState(false);
    const [userSaveLoader, setUserSaveLoader] = useState(false);
    const [showErrors, setShowErrors] = useState(false);
    const [accessedCompanies, setAccessedCompanies] = useState([]);
    const [contactPointIncrKey, setContactPointIncrKey] = useState(0);
    const [installationIncrKey, setInstallationIncrKey] = useState(0);
    const [userIncrKey, setUserIncrKey] = useState(0);
    const [hiddenColumnFields, setHiddenColumnFields] = useState([]);
    const [taxisLoading, setTaxisLoading] = useState(false);
    const [tabCloseWarning, showTabCloseWarning] = useState(false);
    const [isFormDirty, setIsFormDirty] = useState(false);
    const [yearOptions, setYearOptions] = useState([]);
    const [activeCompanyId, setActiveCompanyId] = useState(null);
    const currentYear = moment().year();

    const [loadingDelete, setLoadingDelete] = useState(false);
    const [toDelete, setToDelete] = useState(null);

    const companyContactPointsColumns = [
        {
            name: "Αρ.",
            field: "no",
            editable: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Όνομα",
            field: "name",
            editable: true,
            width: "10%",
            inputType: {
                type: "text",
            },
            required: true,
        },
        {
            name: "Επώνυμο",
            field: "surname",
            editable: true,
            width: "10%",
            inputType: {
                type: "text",
            },
            required: true,
        },
        {
            name: "ΑΦΜ",
            field: "vatNumber",
            editable: true,
            width: "10%",
            inputType: {
                type: "text",
            },
            required: true,
        },
        {
            name: "Κινητό",
            field: "mobile",
            editable: true,
            width: "10%",
            inputType: {
                type: "text",
            },
            required: true,
        },
        {
            name: "Σταθερό",
            field: "landline",
            editable: true,
            width: "10%",
            inputType: {
                type: "text",
            },
        },
        {
            name: "Άλλο Τηλέφωνο",
            field: "otherPhone",
            editable: true,
            width: "10%",
            inputType: {
                type: "text",
            },
        },
        {
            name: "Email",
            field: "email",
            editable: true,
            width: "8%",
            inputType: {
                type: "text",
            },
            required: true,
        },
        {
            name: "Σημειώσεις",
            field: "contactNotes",
            width: "15%",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Αποδοχή Ειδοποιήσεων",
            field: "acceptsNotifications",
            width: "2%",
            editable: true,
            inputType: {
                type: "checkbox",
            },
        },
    ];

    const clientInstallationsColumns = [
        {
            name: "Αριθμός",
            field: "no",
            width: "5%",
            editable: false
        },
        {
            name: "Ενεργό",
            field: "isActive",
            width: "10%",
            editable:true,
            inputType: {
                options: [{label: 'Active', value: "active", color: '#76AEB7'},{label: 'Inactive', value: "inactive", color: '#76AEB7'}],
                type: 'dropdown',
                config: {
                    searchEnable: true
                }
            }
        },
        {
            name: "Κωδ. Εγκατάστασης ΑΑΔΕ",
            field: "installationMasterId",
            width: "5%",
            editable:true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Τύπος",
            field: "type",
            editable: true,
            width: "15%",
            inputType: {
                options: getInstallationsTypes(),
                type: 'dropdown',
                config: {
                    searchEnable: true
                }
            }
        },
        {
            name: "Διεύθυνση",
            field: "address",
            width: "20%",
            editable:true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Ταχυδρομικός Κώδικας",
            field: "postalCode",
            width: "7%",
            editable:true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "ΔΟΥ",
            field: "doy",
            editable: true,
            width: "15%",
            inputType: {
                options: getDOYOptions(),
                type: 'dropdown',
                config: {
                    searchEnable: true
                }
            }
        },
        {
            name: "Πόλη",
            field: "city",
            width: "15%",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Τηλέφωνο",
            field: "phone",
            width: "20%",
            editable: true,
            inputType: {
                type: 'text',
            }
        }
    ];

    const companyUsersColumns = [
        {
            name: "Αριθμός",
            field: "no",
            width: "2%",
            editable: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Όνομα",
            field: "firstName",
            width: "10%",
            editable: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Επώνυμο",
            field: "lastName",
            width: "10%",
            editable: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "User Name",
            field: "userName",
            width: "20%",
            editable: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Email",
            field: "email",
            width: "20%",
            editable: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Ημ/νία Δημιουργίας",
            field: "created_at",
            width: "25%",
            editable: false,
            inputType: {
                type: "text"
            }
        }
    ];

    const newCompanyUsersDraftColumns = [
        {
            name: "No",
            field: "no",
            editable: false,
            width: "5%",
            inputType: { type: "text" }
        },
        {
            name: "Όνομα",
            field: "firstName",
            editable: true,
            width: "30%",
            required: true,
            inputType: { type: "text" }
        },
        {
            name: "Επώνυμο",
            field: "lastName",
            editable: true,
            width: "30%",
            required: true,
            inputType: { type: "text" }
        },
        {
            name: "Email",
            field: "email",
            editable: true,
            width: "35%",
            required: true,
            inputType: { type: "text" }
        }
    ];

    const [tableColumns] = useState(companyContactPointsColumns.slice());
    const [tableUserColumns] = useState(companyUsersColumns.slice());
    const dynamicColumns = clientInstallationsColumns.map((col) => {
        const draftValue = COMPANY_DATA.newInstallation[col.field];
        return {
            ...col,
            hiddenColumn: hiddenColumnFields.includes(col.field),
            inputType: {
                ...col.inputType,
                defaultValue: draftValue !== undefined ? draftValue : ""
            }
        };
    });

    useEffect(() => {
        const generatedYears = [];
        for (let i = 0; i <= 5; i++) {
            const year = currentYear - i;
            generatedYears.push({ value: year, label: String(year) });
        }
        setYearOptions(generatedYears);
    }, [currentYear]);

    useEffect(() => {
        setContactPointIncrKey(contactPointIncrKey + 1);
    }, [COMPANY_DATA.newCompany.contactPoints])

    useEffect(() => {
        setInstallationIncrKey(prev => prev + 1);
    }, [COMPANY_DATA.newCompany.installations]);

    useEffect(() => {
        setUserIncrKey(userIncrKey + 1);
    }, [COMPANY_DATA.newCompany.users]);

    useEffect(() => {
        getCompanyAccess();
    }, []);

    useEffect(() => {
        let newCompanyData = Object.assign({}, COMPANY_DATA.newCompany);
        dispatch(setNewCompany(newCompanyData));
    }, []);

    useEffect(() => {
        axios.post(apiURL2 + `/company/master-public-templates`, {})
            .then((response) => {
                const listData = response.data.data.listData;
                const formattedList = listData.map((item) => ({
                    label: item.name,
                    value: item._id,
                }));
                setCompanyPublicTemplatesList(formattedList);
            })
            .catch((error) => {
                console.error("Error fetching templates:", error);
            });
    }, []);

    useEffect(() => {
        if (showNewModal && companyPublicTemplatesList.length > 0) {
            const firstOption = companyPublicTemplatesList[0];
            if (COMPANY_DATA.newCompany.companyTemplate !== firstOption.value) {
                dispatch(setNewCompany({
                    ...COMPANY_DATA.newCompany,
                    companyTemplate: firstOption.value
                }));
            }
        }
    }, [showNewModal, companyPublicTemplatesList, COMPANY_DATA.newCompany.companyTemplate, COMPANY_DATA.newCompany, dispatch]);

    useEffect(() => {
        if (COMPANY_DATA.activeModal === 'new-company') {
            dispatch(resetSelectedUser());
            setCompanyUsers([]);
            setIsFormDirty(true);
            setShowNewModal(true);
            dispatch(setActiveModal(null));
        }
    }, [COMPANY_DATA.activeModal]);

    const loadUsersListData = (companyId) => {
        axios.post(apiURL2 + `/user/list-company-users`, {company: companyId}, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                if (res.data) {
                    setCompanyUsers(res.data.data);
                } else {
                    setCompanyUsers([]);
                }
            } else {
                setCompanyUsers([]);
            }
            setUserIncrKey(prev => prev + 1);
        }).catch((error) => {
            console.log(error);
            setCompanyUsers([]);
        });
    };

    const onCompanyDelete = () => {
        setLoadingDelete(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/company/delete-company`, {
            company: toDelete,
        }, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής διαγραφή.");
                setToDelete(null);
                getCompanyAccess();
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }).finally(() => {
            setLoadingDelete(false);
        })
    }

    const handleOnChange = async (e, type = "default", ddname = "") => {
        setShowErrors(true);
        if (!isFormDirty) setIsFormDirty(true);
        if (!ACTIVITY.saveNewCompany) dispatch(setSaveNewCompany(true));

        let name, value;
        if (type === "date" || type === "datebox") { name = ddname; value = e; }
        else if (type === "dd") { name = ddname; value = e.value; }
        else if (type === "ac") { name = ddname; value = e.row.value; }
        else if (type === "cb") { name = ddname; value = e.target.checked; }
        else { name = e.target.name; value = e.target.value; }

        if (ddname === "doy") value = e.label;
        if (ddname === "companyTemplate") value = e.value;

        let newCompany = Object.assign({}, COMPANY_DATA.newCompany);
        let newCompanyData = {};
        if (e.target && e.target.name === 'vatNumber') newCompanyData["isFromTaxis"] = false;
        newCompanyData[name] = value;
        newCompany = { ...newCompany, ...newCompanyData };

        if (name === "capital") newCompany.stockholders = recalculateStockHolders(newCompany.stockholders, parseFloat(value));
        const defaultOption = getMainInstallation();
        const defaultTypeId = defaultOption ? defaultOption.value : "1";
        const allDoyOptions = getDOYOptions();
        const foundDoy = allDoyOptions.find(opt => opt.label === newCompany.doy);
        const doyCodeForTable = foundDoy ? foundDoy.value : "";
        let currentInstallations = newCompany.installations ? [...newCompany.installations] : [];
        let preservedMasterId = 0;
        if (currentInstallations.length > 0 && currentInstallations[0]) {
            if (currentInstallations[0].installationMasterId !== undefined && currentInstallations[0].installationMasterId !== "") {
                preservedMasterId = currentInstallations[0].installationMasterId;
            } else if (currentInstallations[0].installationMasterId === "") {
                preservedMasterId = 0;
            }
        }

        const mainInstallationData = {
            no: "1",
            installationMasterId: preservedMasterId,
            type: defaultTypeId,
            address: newCompany.headquartersAddress || "",
            doy: doyCodeForTable || "",
            city: newCompany.city || "",
            postalCode: newCompany.postalCode || "",
            phone: newCompany.phone || "",
            isActive: "active"
        };

        if (currentInstallations.length > 0) {
            currentInstallations[0] = { ...currentInstallations[0], ...mainInstallationData };
        } else {
            currentInstallations = [mainInstallationData];
        }
        dispatch(setNewCompany({ ...newCompany, installations: currentInstallations }));
    }

    const handleUserChange = (e) => {
        if (!isFormDirty) setIsFormDirty(true);
        const { name, value } = e.target;
        let updatedUser = { ...COMPANY_DATA.selectedUser };
        updatedUser[name] = value;
        dispatch(setSelectedUser(updatedUser));
    }

    const parentMydataActions = {
        insert: (e, data) => {
            if (!isFormDirty) setIsFormDirty(true);
            if (!ACTIVITY.saveNewCompany) dispatch(setSaveNewCompany(true));
            let tempContactPoint = Object.assign({}, COMPANY_DATA.newContactPoint);
            if (e.key !== "Enter") {
                tempContactPoint[data.field] = data.value;
                dispatch(setNewContactPoint(tempContactPoint));
                if (data.value !== "") {
                    let updated = Object.assign({}, tempContactPoint);
                    let oldPoints = COMPANY_DATA.newCompany.contactPoints || [];
                    updated.no = oldPoints.length + 1;
                    updated.id = oldPoints.length + 1;
                    dispatch(setNewCompany({
                        ...COMPANY_DATA.newCompany,
                        contactPoints: [...oldPoints, updated],
                    }));
                    dispatch(setNewContactPoint(COMPANY_DATA.newContactPointInitialValue));
                }
            }
            // 2. Handle "Add" button or Enter key
            else if (data.value === "add") {
                let updated = Object.assign({}, tempContactPoint);
                let oldPoints = COMPANY_DATA.newCompany.contactPoints || [];

                updated.no = oldPoints.length + 1;
                updated.id = oldPoints.length + 1;

                dispatch(setNewCompany({
                    ...COMPANY_DATA.newCompany,
                    contactPoints: [...oldPoints, updated],
                }));
                dispatch(setNewContactPoint(COMPANY_DATA.newContactPointInitialValue));
            }
        },

        update: (data, id) => {
            if (!isFormDirty) setIsFormDirty(true);
            if (!ACTIVITY.saveNewCompany) dispatch(setSaveNewCompany(true));
            if (data.name !== undefined && data.name.length === 0) {
                toast.error("Το πεδίο Όνομα Επαφής είναι υποχρεωτικό");
            }
            let contactPoints = [...COMPANY_DATA.newCompany.contactPoints];
            let targetIndex;
            if (typeof id === 'number' && contactPoints[id]) {
                targetIndex = id;
            } else {
                targetIndex = contactPoints.findIndex(item => String(item.id) === String(id));
            }
            if (targetIndex !== -1) {
                contactPoints[targetIndex] = { ...contactPoints[targetIndex], ...data };
                dispatch(setNewCompany({ ...COMPANY_DATA.newCompany, contactPoints: contactPoints }));
            }
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!isFormDirty) setIsFormDirty(true);
            if (!ACTIVITY.saveNewCompany) dispatch(setSaveNewCompany(true));
            let contactPoints = [...COMPANY_DATA.newCompany.contactPoints];
            if (rowIndex !== 0 && contactPoints.length >= 2) {
                contactPoints.splice(rowIndex, 1);
                const updatedContactPoints = contactPoints.map((item, index) => ({
                    ...item,
                    no: index + 1,
                    id: index + 1,
                }));

                dispatch(setNewCompany({ ...COMPANY_DATA.newCompany, contactPoints: updatedContactPoints }));
            } else {
                toast.error("Η πρώτη γραμμή δεν μπορεί να διαγραφεί.");
            }
        },
    };

    const usersTableFunctions = {
        insert: (e, data) => {
            if (!isFormDirty) setIsFormDirty(true);
            if (!ACTIVITY.saveNewCompany) dispatch(setSaveNewCompany(true));
            const generatePassword = () => {
                const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                let result = '';
                for (let i = 0; i < 10; i++) {
                    result += characters.charAt(Math.floor(Math.random() * characters.length));
                }
                return result;
            };

            if (data.value !== "" || data.field === "add") {
                let currentUsers = [...(COMPANY_DATA.newCompany.users || [])];
                const nextNo = currentUsers.length + 1;
                const newUserObj = {
                    no: nextNo,
                    firstName: data.field === "firstName" ? data.value : "",
                    lastName: data.field === "lastName" ? data.value : "",
                    email: data.field === "email" ? data.value : "",
                    userName: data.field === "email" ? data.value : "",
                    password: generatePassword(),
                    userType: "User",
                    newUser: "true",
                    lang: "el",
                    status: 'Active',
                    canAccessExpired: 'inactive',
                    sendCredentials: "true",
                    permissions: [{ permissionName: "custom-cloud" }]
                };
                currentUsers.push(newUserObj);
                dispatch(setNewCompany({ ...COMPANY_DATA.newCompany, users: currentUsers }));
            }
        },
        update: (data, id, rowIndex) => {
            if (!isFormDirty) setIsFormDirty(true);
            let currentUsers = [...(COMPANY_DATA.newCompany.users || [])];
            if (currentUsers[rowIndex]) {
                let updatedUser = { ...currentUsers[rowIndex], ...data };
                if (data.email !== undefined) {
                    updatedUser.userName = data.email;
                }
                currentUsers[rowIndex] = updatedUser;
                dispatch(setNewCompany({ ...COMPANY_DATA.newCompany, users: currentUsers }));
            }
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!isFormDirty) setIsFormDirty(true);
            let currentUsers = [...(COMPANY_DATA.newCompany.users || [])];
            currentUsers.splice(rowIndex, 1);
            currentUsers = currentUsers.map((u, index) => ({ ...u, no: index + 1 }));
            dispatch(setNewCompany({ ...COMPANY_DATA.newCompany, users: currentUsers }));
        }
    };

    const getTaxiNetDetails = async (data) => {
        if (data === "" || data === null || data === undefined) {
            toast.error("Παρακαλώ εισάγετε ένα ΑΦΜ πρώτα");
            return;
        }
        if (!validateAFM(data)) {
            toast.error("Το ΑΦΜ δεν είναι έγκυρο.");
            return;
        }
        setTaxisLoading(true);
        const d = {
            vatNumber: data,
            onlyAADE: "true",
        };
        const abort = axios.CancelToken.source();
        const timer = setTimeout(() => abort.cancel(`timeout`), 10000);
        axios
            .post(apiURL2 + `/client/fetch-vat-details`, d)
            .then((res) => {
                if (res.data && res.data.status === "200") {
                    if (!isFormDirty) setIsFormDirty(true);
                    if (!ACTIVITY.saveNewCompany) dispatch(setSaveNewCompany(true));
                    clearTimeout(timer);
                    let companyDetails = res.data.data;
                    let newCompany = Object.assign({}, COMPANY_DATA.newCompany);
                    newCompany.isFromTaxis = true;
                    newCompany.name = companyDetails?.name !== undefined ? companyDetails?.name : "";
                    newCompany.smallName = companyDetails?.smallName !== undefined ? companyDetails?.smallName : "";
                    newCompany.activity = companyDetails?.activity !== undefined ? companyDetails?.activity : "";
                    newCompany.postalCode = companyDetails?.tk !== undefined ? companyDetails?.tk : "";
                    const foundDoyOption = getDefaultOptionByValue(getDOYOptions(), Number(companyDetails?.doyCode), "value", "label", "value");
                    newCompany.doy = foundDoyOption.label;
                    newCompany.city = companyDetails?.city !== undefined ? companyDetails?.city : "";
                    newCompany.headquartersAddress = companyDetails?.address !== undefined ? companyDetails?.address : companyDetails?.headquartersAddress;
                    if (companyDetails.regist_date) newCompany.companyEstablishedDate = moment(companyDetails.regist_date, "YYYY-MM-DD").startOf("day").add(10, "hours").toDate();
                    const allDoyOptions = getDOYOptions();
                    const selectedDoyOption = allDoyOptions.find((option) => option.label === newCompany.doy);
                    const doyValueForTable = selectedDoyOption ? selectedDoyOption.value : "";
                    const defaultTypeID = getMainInstallation()?.value || "1";

                    let defaultInstallation = [
                        {
                            no: "1",
                            installationMasterId: 0,
                            type: defaultTypeID,
                            address: newCompany.headquartersAddress,
                            doy: doyValueForTable,
                            city: newCompany.city,
                            postalCode: newCompany.postalCode,
                            phone: newCompany.phone,
                            isActive: "active"
                        },
                    ];
                    dispatch(setNewCompany({...newCompany, installations: defaultInstallation}));
                    toast.success("Επιτυχία");
                    setTaxisLoading(false);
                }
                if (res.data && res.data.status === "422") {
                    setTaxisLoading(false);
                    toast.error("Permissions not found.");
                }
                if (res.data && res.data.status === "400") {
                    setTaxisLoading(false);
                    toast.error(res.data.message);
                }
            })
            .catch((error) => {
                setTaxisLoading(false);
                if (
                    error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.errors
                ) {
                    toast.error(error.response.data.errors);
                }
            });
    };

    const installationsTableFunctions = {
        insert: (e, data) => {
            if (!isFormDirty) setIsFormDirty(true);
            let tempInstallations = Object.assign({}, COMPANY_DATA.newInstallation);

            if (e.key !== "Enter") {
                tempInstallations[data.field] = data.value;
                dispatch(setNewInstallations(tempInstallations));

                let oldInstallations = COMPANY_DATA.newCompany.installations || [];
                if (data.field === "no" && !isEmpty(data.value)) {
                    const findDuplicate = oldInstallations.filter(inst => String(inst.no) === String(data.value));
                    if (findDuplicate.length > 0) {
                        toast.error("Ο Αριθμός Εγκατάστασης υπάρχει ήδη.");
                        return;
                    }
                }

                let updated = Object.assign({}, tempInstallations);
                const isRowFull =
                    !isEmpty(updated.type) && !isEmpty(updated.address) &&
                    !isEmpty(updated.doy) && !isEmpty(updated.city) &&
                    !isEmpty(updated.postalCode) && !isEmpty(updated.phone);
                if (isRowFull) {
                    let finalNo = updated.no;
                    if (isEmpty(finalNo)) {
                        const maxNo = oldInstallations.reduce((max, c) => Math.max(max, parseInt(c.no || 0)), 0);
                        finalNo = String(maxNo + 1);
                    } else {
                        finalNo = String(finalNo);
                    }

                    let newRow = {
                        ...updated,
                        no: finalNo,
                        installationMasterId: updated.installationMasterId || "0",
                        isActive: updated.isActive || "active"
                    };

                    const cloneData = [...oldInstallations];
                    cloneData.push(newRow);
                    dispatch(setNewCompany({ ...COMPANY_DATA.newCompany, installations: cloneData }));
                    dispatch(resetNewInstallations());
                    dispatch(setSaveNewCompany(true));
                }
            } else {
                let updated = Object.assign({}, COMPANY_DATA.newInstallation);
                let oldInstallations = COMPANY_DATA.newCompany.installations || [];
                if (data.field === 'add' || e.key === 'Enter') {
                    if (updated && !isEmpty(updated.type)) {
                        let finalNo = updated.no;
                        if (isEmpty(finalNo)) {
                            const maxNo = oldInstallations.reduce((max, c) => Math.max(max, parseInt(c.no || 0)), 0);
                            finalNo = String(maxNo + 1);
                        }
                        let newRow = {
                            ...updated,
                            no: finalNo,
                            installationMasterId: updated.installationMasterId || "0",
                            isActive: updated.isActive || "active"
                        };

                        const cloneData = [...oldInstallations];
                        cloneData.push(newRow);
                        dispatch(setNewCompany({ ...COMPANY_DATA.newCompany, installations: cloneData }));
                        dispatch(resetNewInstallations());
                        dispatch(setSaveNewCompany(true));
                    }
                }
            }
        },
        update: (data, id, rowIndex) => {
            if (!isFormDirty) setIsFormDirty(true);
            if (!ACTIVITY.saveNewCompany) dispatch(setSaveNewCompany(true));
            let installations = [...COMPANY_DATA.newCompany.installations];
            if (rowIndex >= 0 && installations[rowIndex]) {
                if (data?.no) {
                    const findDuplicate = installations.filter((inst, index) => String(inst.no) === String(data.no) && index !== rowIndex);
                    if (findDuplicate.length > 0) {
                        toast.error("Ο Αριθμός Εγκατάστασης υπάρχει ήδη.");
                        return;
                    }
                }

                installations[rowIndex] = { ...installations[rowIndex], ...data };
                dispatch(setNewCompany({ ...COMPANY_DATA.newCompany, installations: installations }));
            }
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!isFormDirty) setIsFormDirty(true);
            if (!ACTIVITY.saveNewCompany) dispatch(setSaveNewCompany(true));
            if (rowIndex === 0) {
                toast.error("Η πρώτη γραμμή δεν μπορεί να διαγραφεί.");
                return;
            }
            let installations = [...COMPANY_DATA.newCompany.installations];
            if (typeof rowIndex === 'number' && rowIndex > 0) {
                installations.splice(rowIndex, 1);
                dispatch(setNewCompany({ ...COMPANY_DATA.newCompany, installations: installations }));
            }
        }
    };

    const handleColumnShowHide = (field) => {
        if (hiddenColumnFields.includes(field)) {
            setHiddenColumnFields(hiddenColumnFields.filter(f => f !== field));
        } else {
            setHiddenColumnFields([...hiddenColumnFields, field]);
        }
    };

    const getCompanyAccess = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/company/get-user-companies-access`, {
            headers: {"Content-Type": "application/json"},
            params: {
                userId: currentUser._id,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                setAccessedCompanies(res.data.data);
            }
        }).catch((err) => {
            console.log(err);
        })
    };

    const openNewModal = () => {
        dispatch(resetNewCompany());
        dispatch(resetNewInstallations()); // Added reset for installations draft/list
        dispatch(resetSelectedUser());
        setCompanyUsers([]);
        setIsFormDirty(false);
        setShowNewModal(true);
    };

    const openUsersModal = (companyId) => {
        setActiveCompanyId(companyId);
        setCompanyUsers([]);
        loadUsersListData(companyId);
        const currentCompany = accessedCompanies.find(c => String(c._id) === String(companyId));
        let initialUserData = {
            firstName: "",
            lastName: "",
            email: "",
            status: "Active",
            userType: "User",
            canAccessExpired: "inactive",
            sendCredentials: "true",
            companies: [],
            permissions: []
        };
        if (currentCompany) {
            let simpleYears = [];
            if (Array.isArray(currentCompany.years)) {
                simpleYears = currentCompany.years.map(item => {
                    if (typeof item === 'object' && item.year) return item.year;
                    return item;
                }).filter(y => y);
            }

            const newCompanyEntry = {
                vatNumber: currentCompany.vatNumber,
                id: currentCompany._id,
                name: currentCompany.name,
                years: simpleYears
            };

            initialUserData.companies.push(newCompanyEntry);
        }
        initialUserData.permissions.push({ permissionName: "custom-cloud" });
        dispatch(setSelectedUser(initialUserData));
        setIsFormDirty(false);
        setShowErrors(false);
        setShowUsersModal(true);
    };

    const handleCloseAttempt = () => {
        if (isFormDirty) {
            showTabCloseWarning(true);
        } else {
            closeNewModal();
            closeUsersModal();
        }
    };

    const closeNewModal = () => {
        setCompanySaveLoader(null);
        setShowNewModal(false);
    };

    const closeUsersModal = () => {
        setUserSaveLoader(null);
        setShowUsersModal(false);
    };

    const closeConfirm = () => {
        showTabCloseWarning(false);
        if (showNewModal) {
            setShowNewModal(false);
            dispatch(resetNewCompany());
            dispatch(resetNewInstallations());
            setCompanySaveLoader(false);
        }
        if (showUsersModal) {
            setShowUsersModal(false);
            dispatch(resetSelectedUser());
            setUserSaveLoader(false);
        }
        setIsFormDirty(false);
        setShowErrors(false);
    };

    const validateUserPayload = (silent = false) => {
        const newUser = COMPANY_DATA.selectedUser;
        const fail = (message) => {
            if (!silent) {
                toast.error(message);
            }
            return false;
        };
        if (isEmpty(newUser.firstName)) return fail("Το όνομα του χρήστη είναι υποχρεωτικό");
        if (isEmpty(newUser.lastName)) return fail("Το επώνυμο του χρήστη είναι υποχρεωτικό");
        if (isEmpty(newUser.email)) return fail("Το Email του χρήστη είναι υποχρεωτικό");
        if (!isValidEmail(newUser.email)) return fail("Το Email δεν είναι έγκυρο");
        if (isValueAlreadyExists(companyUsers, newUser.email, "email")) return fail("Το Email υπάρχει ήδη");
        return true;
    };

    const validatePayload = (silent = false) => {
        const newCompany = COMPANY_DATA.newCompany;
        const fail = (message) => {
            if (!silent) {
                toast.error(message);
            }
            return false;
        };
        if (isEmpty(newCompany.yearFrom)) return fail("Παρακαλώ επιλέξτε 'Έτος Από'");
        if (isEmpty(newCompany.name)) return fail("Το Όνομα Εταιρείας είναι υποχρεωτικό");
        if (isEmpty(newCompany.vatNumber)) return fail("Το πεδίο ΑΦΜ είναι υποχρεωτικό");
        if (isEmpty(newCompany.doy)) return fail("Το πεδίο ΔΟΥ είναι υποχρεωτικό");
        if (isEmpty(newCompany.activity)) return fail("Η Δραστηριότητα είναι υποχρεωτική");
        if (isEmpty(newCompany.country)) return fail("Το πεδίο Χώρα είναι υποχρεωτικό");
        if (isEmpty(newCompany.headquartersAddress)) return fail("Η Διεύθυνση Έδρας είναι υποχρεωτική");
        if (isEmpty(newCompany.city)) return fail("Η Πόλη είναι υποχρεωτική.");
        if (isEmpty(newCompany.postalCode)) return fail("Ο Ταχυδρομικός Κώδικας είναι υποχρεωτικός");
        if (isEmpty(newCompany.phone)) return fail("Το Τηλέφωνο είναι υποχρεωτικό");
        if (isEmpty(newCompany.email)) return fail("Το πεδίο Email είναι υποχρεωτικό");
        if (!isValidEmail(newCompany.email)) return fail("Το Email δεν είναι έγκυρο.");
        if (!validateAFM(newCompany.vatNumber)) return fail("Το ΑΦΜ είναι λανθασμένο.");
        if (isEmpty(newCompany.companyTemplate)) return fail("Το Πρότυπο Εταιρείας είναι υποχρεωτικό");
        if (newCompany.contactPoints && newCompany.contactPoints.length > 0) {
            let hasRepresentative = false;
            for (let i = 0; i < newCompany.contactPoints.length; i++) {
                const contact = newCompany.contactPoints[i];
                if (isEmpty(contact.name) ||
                    isEmpty(contact.surname) ||
                    isEmpty(contact.vatNumber) ||
                    isEmpty(contact.mobile) ||
                    isEmpty(contact.email)) {

                    return fail(`Παρακαλώ συμπληρώστε όλα τα στοιχεία για την επαφή ${i + 1} (Όνομα, Επώνυμο, ΑΦΜ, Κινητό, Email).`);
                }
                if (String(contact.acceptsNotifications) === "true") {
                    hasRepresentative = true;
                }
            }
            if (!hasRepresentative) return fail("Παρακαλώ επιλέξτε τουλάχιστον μια επαφή για αποδοχή ειδοποιήσεων.");
        }
        if (newCompany.installations && newCompany.installations.length > 0) {
            for (let i = 0; i < newCompany.installations.length; i++) {
                const installation = newCompany.installations[i];
                if (isEmpty(installation.installationMasterId) ||
                    isEmpty(installation.type) ||
                    isEmpty(installation.address) ||
                    isEmpty(installation.city) ||
                    isEmpty(installation.postalCode) ||
                    isEmpty(installation.phone)
                ) {
                    return fail(`Παρακαλώ συμπληρώστε όλα τα στοιχεία της εγκατάστασης ${i + 1}.`);
                }
            }
        }
        return true;
    }

    const saveNewCompany = () => {
        const companyData = {
            ...COMPANY_DATA.newCompany,
            createdFromUser: currentUser._id,
        };

        if (validatePayload() === false) {
            setShowErrors(true);
            return;
        }

        const draftUsers = companyData.users?.filter(u => String(u.newUser) === "true") || [];
        for (const draftUser of draftUsers) {
            if (isEmpty(draftUser.firstName) || isEmpty(draftUser.lastName) || !isValidEmail(draftUser.email)) {
                toast.error(`Παρακαλώ συμπληρώστε όλα τα πεδία για τον χρήστη (Γραμμή ${draftUser.no || ''}).`);
                setShowErrors(true);
                return;
            }
        }

        if (companyData.installations && companyData.installations.length > 0) {
            const allTypeOptions = getInstallationsTypes();
            const allDoyOptions = getDOYOptions();
            companyData.installations = companyData.installations.map((inst) => {
                const foundType = allTypeOptions.find(opt => String(opt.value) === String(inst.type));
                const finalType = foundType ? foundType.label : inst.type;
                const foundDoy = allDoyOptions.find(opt => String(opt.value) === String(inst.doy));
                const finalDoy = foundDoy ? foundDoy.label : inst.doy;

                let finalActive = "inactive";
                if(inst.isActive && (String(inst.isActive).toLowerCase() === "active" || String(inst.isActive) === "true")) {
                    finalActive = "active";
                }

                return { ...inst, type: finalType, doy: finalDoy, isActive: finalActive };
            });
        }

        if (companyData.stockholders && companyData.stockholders.length > 0) {
            const positionOptions = getStockholderPositions();
            companyData.stockholders = companyData.stockholders.map((holder) => {
                const foundByLabel = positionOptions.find(opt => opt.label === holder.position);
                const finalPosition = foundByLabel ? foundByLabel.value : holder.position;
                return { ...holder, position: finalPosition };
            });
        }

        if (companyData.users && companyData.users.length > 0) {
            companyData.users = companyData.users.map(u => {
                if (String(u.newUser) === "true") {
                    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                    let generatedPassword = '';
                    for (let i = 0; i < 10; i++) {
                        generatedPassword += characters.charAt(Math.floor(Math.random() * characters.length));
                    }

                    return {
                        firstName: u.firstName,
                        lastName: u.lastName,
                        email: u.email,
                        userName: u.email,
                        password: generatedPassword,
                        sendCredentials: "true",
                        userType: "User",
                        lang: "el",
                        status: 'Active',
                        canAccessExpired: 'inactive',
                        telephoneId: "",
                        permissions: [{ permissionName: "custom-cloud" }]
                    };
                }
                return u;
            });
        }

        setCompanySaveLoader(true);
        axios.post(apiURL2 + `/company/add-in-master`, companyData, {
            headers: { "Content-Type": "application/json" },
        })
            .then((res) => {
                if (res.data && res.data.status === "200") {
                    toast.success("Η νέα εταιρεία αποθηκεύτηκε επιτυχώς");
                    finalizeCreation();
                } else {
                    toast.error(res.data.message || "Αποτυχία αποθήκευσης.");
                    setCompanySaveLoader(false);
                }
            })
            .catch((error) => {
                console.error(error);
                if (error?.response?.status === 401) {
                    toast.error("Η συνεδρία έληξε. Συνδεθείτε ξανά.");
                } else if (
                    error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.errors
                ) {
                    toast.error(error.response.data.errors);
                } else {
                    toast.error("An unexpected error occurred.");
                }
                setCompanySaveLoader(false);
            });
    };

    const finalizeCreation = () => {
        getCompanyAccess();
        dispatch(resetNewCompany());
        dispatch(resetNewInstallations());
        dispatch(resetSelectedUser());
        setCompanyUsers([]);
        setIsFormDirty(false);
        setCompanySaveLoader(false);
        closeNewModal();
    };

    const saveNewUser = () => {
        const isValid = validateUserPayload();
        if (isValid === false) {
            setShowErrors(true);
            return;
        }
        let payload = {
            ...COMPANY_DATA.selectedUser,
            company: activeCompanyId
        };
        if (!payload.password) {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let password = '';
            for (let i = 0; i < 10; i++) {
                password += characters.charAt(Math.floor(Math.random() * characters.length));
            }
            payload.password = password;
        }
        if (!payload.userName) {
            payload.userName = payload.email;
        }

        setUserSaveLoader(true);
        axios.post(apiURL2 + `/user/add-in-master`, payload, {
            headers: { "Content-Type": "application/json" },
        })
            .then((res) => {
                if (res.data && res.data.status === "200") {
                    toast.success("Ο νέος χρήστης δημιουργήθηκε επιτυχώς");
                    dispatch(resetSelectedUser());
                    setIsFormDirty(false);
                    setUserSaveLoader(false);
                    if (activeCompanyId) {
                        loadUsersListData(activeCompanyId);
                    }
                } else {
                    toast.error(res.data.message || "Αποτυχία.");
                    setUserSaveLoader(false);
                }
            })
            .catch((error) => {
                console.error(error);
                if (error?.response?.status === 401) {
                    toast.error("Η συνεδρία έληξε. Συνδεθείτε ξανά.");
                } else if (
                    error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.errors
                ) {
                    toast.error(error.response.data.errors);
                } else {
                    toast.error("An unexpected error occurred.");
                }
                setUserSaveLoader(false);
            });
    };

    const filteredCompanies = accessedCompanies.filter((company) => {
        if (!COMPANY_DATA.searchTerm) return true;
        const lowerTerm = COMPANY_DATA.searchTerm.toLowerCase();
        const nameMatch = company.name
            ? company.name.toLowerCase().includes(lowerTerm)
            : false;
        const vatMatch = company.vatNumber
            ? String(company.vatNumber).includes(lowerTerm)
            : false;
        return nameMatch || vatMatch;
    });

    const handleCompanyLogin = (company) => {
        let erpURL = "";
        if (company._id) {
            let companyD = {
                id: company._id,
                name: company.name,
                vatNumber: company.vatNumber,
                year: moment().year(),
            };
            if (currentUser.userType === "Admin") {
                dispatch(setCompany(companyD));
                localStorage.setItem("company", JSON.stringify(companyD));
                filteredCompanies.forEach((c) => {
                    c.years.forEach((y) => {
                        if (String(y.year) === String(moment().year()) && company._id === c._id) {
                            erpURL = y.erp_ip;
                        }
                    })
                });
                toast.success("Η εταιρεία άλλαξε επιτυχώς");
                dispatch(fetchPrimerMyDataCredentials(companyD.id));
                sessionStorage.setItem("company", JSON.stringify(company));
                window.location.replace(`${erpURL}?token=${localStorage.getItem("token")}&company=${JSON.stringify(company)}&device_id=${localStorage.getItem("deviceId")}&erp_ip=${erpURL}`);
            } else {
                let expireDate;
                if (currentUser.primaryCompany) {
                    const primaryCompany = filteredCompanies.find((company) => company._id === currentUser.primaryCompany);
                    expireDate = primaryCompany.companyExpireDate;
                } else expireDate = company.companyExpireDate
                axios.post(process.env.REACT_APP_LOGIN_BACKEND_URL + `/api/public/company/check-company-expiration`, {
                    user: currentUser._id,
                    company: company._id,
                    companyExpireDate: expireDate
                }).then(async (response) => {
                    if (response.data && response.data.success === true) {
                        if (company._id) {
                            for (let i = 0; i < filteredCompanies.length; i++) {
                                if (filteredCompanies[i].years) {
                                    for (let y of filteredCompanies[i].years) {
                                        if ((y.year === moment().year() || y.year === moment().year().toString()) && company._id === filteredCompanies[i]._id) {
                                            erpURL = y.erp_ip;
                                        }
                                    }
                                }
                            }
                            dispatch(setCompany(companyD));
                            localStorage.setItem("company", JSON.stringify(companyD));
                            filteredCompanies.forEach((c) => {
                                c.years.forEach((y) => {
                                    if (String(y.year) === String(moment().year()) && company._id === c._id) {
                                        erpURL = y.erp_ip;
                                    }
                                })
                            });
                            toast.success("Η εταιρεία άλλαξε επιτυχώς");
                            dispatch(fetchPrimerMyDataCredentials(companyD.id));
                            sessionStorage.setItem("company", JSON.stringify(company));
                            const escapedData = encodeURIComponent(JSON.stringify(company));
                            window.location.replace(`${erpURL}?token=${localStorage.getItem("token")}&company=${escapedData}&device_id=${localStorage.getItem("deviceId")}&erp_ip=${erpURL}`);
                        } else {
                            toast.error("Παρακαλώ επιλέξτε εταιρεία");
                        }
                    } else {
                        if (response?.data?.data && response?.data?.data?.showExpired) {
                            if (permissionsData.some((el) => el.permissionName === "custom-companyCreator")) {
                                toast.error("Η Κύρια εταιρία έχει λήξει!");
                            } else {
                                toast.error("Η εταιρία έχει λήξει!");
                            }
                        }
                    }
                }).catch(error => {
                    console.log(error);
                })
            }
        }
    }

    const isSaveUserEnabled = validateUserPayload(true);

    return (
        <React.Fragment>
            <Row>
                <Col md={3}>
                    <Button onClick={() => openNewModal()}>Δημιουργία εταιρείας</Button>
                </Col>
            </Row>
            <Row className={"border-top mt-2 pt-2"}>
                <Col md={3} sm={12} className={"mb-3"}>
                    <Input
                        label="Αναζήτηση Εταιρειών"
                        name="searchCompany"
                        type="text"
                        placeholder="Αναζήτηση με Όνομα ή ΑΦΜ..."
                        value={COMPANY_DATA.searchTerm}
                        autoComplete="off"
                        onChange={(e) => dispatch(setSearchTerm(e.target.value))}
                        className="w-100"
                    />
                </Col>
            </Row>
            <Row className={"mb-3"}>
                <Col md={12}>
                    <table className={"simpleClassicTable simpleClassicTableGrayHover"} style={{fontSize: "14px"}} >
                        <colgroup>
                            <col span={1} style={{width: "5%", padding: "3px"}}></col>
                            <col span={1} style={{width: "55%", padding: "3px"}}></col>
                            <col span={1} style={{width: "20%", padding: "3px"}}></col>
                            <col span={1} style={{width: "20%", padding: "3px"}}></col>
                        </colgroup>
                        <thead>
                        <tr>
                            <th>Αριθμός</th>
                            <th>Όνομα Εταιρείας</th>
                            <th>ΑΦΜ</th>
                            <th>Ενέργειες</th>
                        </tr>
                        </thead>
                        <tbody>
                        {filteredCompanies.length > 0 ? (
                            filteredCompanies.map((company, index) => {
                                return (
                                    <tr key={`comp-${index}`}>
                                        <td>{index + 1}</td>
                                        <td>{company.name}</td>
                                        <td>{company.vatNumber}</td>
                                        <td>
                                            <Badge className={"mx-1"} bg={"primary"} style={{cursor: "pointer"}} title={"Διαχείρηση χρηστών"} onClick={() => openUsersModal(company._id)}>
                                                <i className={"fa fa-users"}></i>
                                            </Badge>
                                            <Badge className={"mx-1"} bg={"primary"} style={{cursor: "pointer"}} title={`Σύνδεση στην εταιρεία ${company.name}`} onClick={() => handleCompanyLogin(company)}>
                                                <i className={"fa fa-sign-in"}></i>
                                            </Badge>
                                            {company.deletableCompany && (
                                                <Badge className={"mx-1"} bg={"danger"} style={{cursor: "pointer"}} title={"Διαγραφή εταιρείας"} onClick={() => setToDelete(company._id)}>
                                                    <MdDelete />
                                                </Badge>
                                            )}
                                        </td>
                                    </tr>
                                )
                            })
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center p-2 text-muted h5">
                                    Δεν βρέθηκαν αποτελέσματα.
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </Col>
            </Row>

            <Modal backdrop={"static"} show={showNewModal} onHide={handleCloseAttempt} dialogClassName={"modal95PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Δημιουργία Νέας Εταιρείας</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="new-client-general product-form position-relative">
                        <Row className="border-bottom">
                            <Col sm={12} md={2}>
                                <DateBox
                                    classes="w-100 mb-2"
                                    label="Ημερομηνία 'Ιδρυσης Εταιρείας"
                                    name="companyEstablishedDate"
                                    selected={moment(COMPANY_DATA.newCompany.companyEstablishedDate).isValid() ? moment(COMPANY_DATA.newCompany.companyEstablishedDate).toDate() : moment().toDate()}
                                    onChange={(e) => handleOnChange(e, "date", "companyEstablishedDate")}
                                    disabled={COMPANY_DATA.newCompany.isFromTaxis && !!COMPANY_DATA.newCompany.companyEstablishedDate}
                                />
                            </Col>
                            <Col sm={12} md={2}>
                                <Dropdown
                                    label="Έτος Από"
                                    classes="w-100"
                                    required={true}
                                    searchEnable={true}
                                    name="yearFrom"
                                    key={Math.random()}
                                    autoComplete={"off"}
                                    options={yearOptions}
                                    onChange={(e) => handleOnChange(e, "dd", "yearFrom")}
                                    defaultValue={getDefaultOptionByValue(yearOptions, COMPANY_DATA.newCompany.yearFrom, "value", "label", "value")}
                                />
                            </Col>
                            <Col sm={12} md={3}>
                                <Dropdown
                                    label="Αρχικό Πρότυπο Δεδομένων Εταιρείας"
                                    classes="w-100 mb-2"
                                    required={true}
                                    searchEnable={true}
                                    name="companyDataPublicTemplate"
                                    autoComplete={"off"}
                                    key={Math.random()}
                                    defaultValue={getDefaultOptionByValue(companyPublicTemplatesList, COMPANY_DATA.newCompany.companyTemplate, "value", "label", "value")}
                                    options={companyPublicTemplatesList}
                                    onChange={(e) => handleOnChange(e, "dd", "companyTemplate")}
                                    disabled={true}
                                />
                                {showErrors && COMPANY_DATA.newCompany.companyTemplate === "" && (
                                    <div className="text-danger">Το πρότυπο εταιρείας είναι υποχρεωτικό</div>
                                )}
                            </Col>
                        </Row>
                        <Row>
                            <div className={"text-muted mt-1 mb-1"}><i>Στοιχεία Επιχείρησης</i></div>
                        </Row>
                        <Row>
                            <Col sm="12" md="2">
                                <div className="mb-2">
                                    <Input
                                        label="ΑΦΜ"
                                        className="w-100 bg-white"
                                        name="vatNumber"
                                        required={true}
                                        type="number"
                                        value={COMPANY_DATA.newCompany.vatNumber}
                                        autoComplete={"off"}
                                        placeholder="Εισάγετε ΑΦΜ"
                                        onChange={(e) => handleOnChange(e)}
                                    />
                                    {showErrors &&
                                        COMPANY_DATA.newCompany.vatNumber !== "" &&
                                        !validateAFM(COMPANY_DATA.newCompany.vatNumber) && (
                                            <div className="text-danger">Το ΑΦΜ δεν είναι έγκυρο.</div>
                                        )}
                                    {showErrors && COMPANY_DATA.newCompany.vatNumber === "" && (
                                        <div className="text-danger">Το πεδίο ΑΦΜ είναι υποχρεωτικό</div>
                                    )}
                                </div>
                            </Col>
                            <Col sm="12" md="2" className="d-flex align-items-center">
                                <Button
                                    onClick={() => getTaxiNetDetails(COMPANY_DATA.newCompany.vatNumber)}
                                    size="sm"
                                    type="button"
                                    disabled={taxisLoading || !validateAFM(COMPANY_DATA.newCompany.vatNumber)}
                                >
                                    {taxisLoading && (
                                        <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    )}
                                    {taxisLoading ? "Εισαγωγή δεδομένων από TAXIS..." : "Εισαγωγή δεδομένων από TAXIS NET"}
                                </Button>
                            </Col>
                            <Col sm="12" md="4">
                                <div className="mb-2">
                                    <Input
                                        label="Όνομα Εταιρείας"
                                        required={true}
                                        className="w-100"
                                        name="name"
                                        charLimit={1000}
                                        type="text"
                                        value={COMPANY_DATA.newCompany.name}
                                        placeholder="Εισάγετε Όνομα"
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChange(e)}
                                        disabled={COMPANY_DATA.newCompany.isFromTaxis && !!COMPANY_DATA.newCompany.name}
                                    />
                                    {showErrors && COMPANY_DATA.newCompany.name === "" && (
                                        <div className="text-danger">Το όνομα είναι υποχρεωτικό</div>
                                    )}
                                    {showErrors &&
                                        COMPANY_DATA.newCompany.name !== "" &&
                                        isValueAlreadyExists(
                                            COMPANY_DATA.companies || [],
                                            COMPANY_DATA.newCompany.name,
                                            "name"
                                        ) && <div className="text-danger">Το όνομα υπάρχει ήδη.</div>}
                                </div>
                            </Col>
                            <Col sm="12" md="4">
                                <Input
                                    label="Διακριτικός Τίτλος Εταιρείας"
                                    className="mb-2 w-100"
                                    name="smallName"
                                    type="text"
                                    value={COMPANY_DATA.newCompany.smallName}
                                    autoComplete={"off"}
                                    placeholder="Εισάγετε Διακριτικό Τίτλο"
                                    onChange={(e) => handleOnChange(e)}
                                    disabled={COMPANY_DATA.newCompany.isFromTaxis && !!COMPANY_DATA.newCompany.smallName}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12" md="2">
                                <Dropdown
                                    label="ΔΟΥ"
                                    classes="w-100"
                                    required={true}
                                    searchEnable={true}
                                    name="doy"
                                    key={Math.random()}
                                    autoComplete={"off"}
                                    defaultValue={getDefaultOptionByValue(getDOYOptions(), COMPANY_DATA.newCompany.doy, "label", "label", "value")}
                                    options={getDOYOptions()}
                                    onChange={(e) => handleOnChange(e, "dd", "doy")}
                                    disabled={COMPANY_DATA.newCompany.isFromTaxis && !!COMPANY_DATA.newCompany.doy}
                                />
                                {showErrors && COMPANY_DATA.newCompany.doy === "" && (
                                    <div className="text-danger">Το πεδίο ΔΟΥ είναι υποχρεωτικό</div>
                                )}
                            </Col>
                            <Col sm="12" md="3">
                                <Input
                                    label="Δραστηριότητα"
                                    className="w-100"
                                    name="activity"
                                    type="text"
                                    required={true}
                                    charLimit={200}
                                    autoComplete={"off"}
                                    value={COMPANY_DATA.newCompany.activity}
                                    placeholder="Εισάγετε Δραστηριότητα"
                                    onChange={(e) => handleOnChange(e)}
                                    disabled={COMPANY_DATA.newCompany.isFromTaxis && !!COMPANY_DATA.newCompany.activity}
                                />
                                {showErrors && COMPANY_DATA.newCompany.activity === "" && (
                                    <div className="text-danger">Η Δραστηριότητα είναι υποχρεωτική</div>
                                )}
                            </Col>
                            <Col sm="12" md="4">
                                <div className="mb-2">
                                    <Input
                                        label="Διεύθυνση"
                                        className="w-100"
                                        name="headquartersAddress"
                                        type="text"
                                        charLimit={200}
                                        required={false}
                                        autoComplete={"off"}
                                        value={COMPANY_DATA.newCompany.headquartersAddress}
                                        placeholder="Εισάγετε Διεύθυνση Έδρας"
                                        onChange={(e) => handleOnChange(e)}
                                        disabled={COMPANY_DATA.newCompany.isFromTaxis && !!COMPANY_DATA.newCompany.headquartersAddress}
                                    />
                                    {showErrors &&
                                        COMPANY_DATA.newCompany.headquartersAddress === "" && (
                                            <div className="text-danger">Το πεδίο Διεύθυνση είναι υποχρεωτικό</div>
                                        )}
                                </div>
                            </Col>
                            <Col sm="12" md="3">
                                <div className="mb-2">
                                    <Input
                                        label="Πόλη"
                                        className="w-100"
                                        name="city"
                                        required={true}
                                        placeholder="Εισάγετε Πόλη"
                                        autoComplete={"off"}
                                        value={COMPANY_DATA.newCompany.city}
                                        onChange={(e) => handleOnChange(e)}
                                        disabled={COMPANY_DATA.newCompany.isFromTaxis && !!COMPANY_DATA.newCompany.city}
                                    />
                                    {showErrors && COMPANY_DATA.newCompany.city === "" && (
                                        <div className="text-danger">Το πεδίο Πόλη είναι υποχρεωτικό</div>
                                    )}
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12" md="2">
                                <div className="mb-2">
                                    <Input
                                        label="Ταχυδρομικός Κώδικας"
                                        className="w-100"
                                        name="postalCode"
                                        placeholder="Εισάγετε ταχυδρομικό κώδικα"
                                        required={true}
                                        autoComplete={"off"}
                                        value={COMPANY_DATA.newCompany.postalCode}
                                        onChange={(e) => handleOnChange(e)}
                                        disabled={COMPANY_DATA.newCompany.isFromTaxis && !!COMPANY_DATA.newCompany.postalCode}
                                    />
                                    {showErrors && COMPANY_DATA.newCompany.postalCode === "" && (
                                        <div className="text-danger">Το πεδίο Τ.Κ. είναι υποχρεωτικό</div>
                                    )}
                                </div>
                            </Col>
                            <Col sm="12" md="3">
                                <div className="mb-2">
                                    <Input
                                        label="Email"
                                        className="w-100"
                                        name="email"
                                        type="email"
                                        value={COMPANY_DATA.newCompany.email}
                                        placeholder="π.χ. test@primer.gr"
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChange(e)}
                                        required={COMPANY_DATA.newCompany.email === ""}
                                    />
                                    {showErrors &&
                                        COMPANY_DATA.newCompany.email !== "" &&
                                        !isValidEmail(COMPANY_DATA.newCompany.email) && (
                                            <div className="text-danger">Το Email δεν είναι έγκυρο.</div>
                                        )}

                                    {showErrors && COMPANY_DATA.newCompany.email === "" && (
                                        <div className="text-danger">Το πεδίο Email είναι υποχρεωτικό</div>
                                    )}
                                </div>
                            </Col>
                            <Col sm="12" md="2">
                                <Input
                                    label="Αριθμός Γ.Ε.Μ.Η"
                                    className="mb-2 w-100"
                                    name="gemhNo"
                                    type="text"
                                    autoComplete={"off"}
                                    value={COMPANY_DATA.newCompany.gemhNo}
                                    placeholder="Εισάγετε Αριθμό Γ.Ε.Μ.Η"
                                    onChange={(e) => handleOnChange(e)}
                                />
                            </Col>
                            <Col sm="12" md="2">
                                <Input
                                    label="Τηλέφωνο"
                                    className="mb-2 w-100"
                                    name="phone"
                                    type="tel"
                                    charLimit={20}
                                    autoComplete={"off"}
                                    value={COMPANY_DATA.newCompany.phone}
                                    placeholder="Εισάγετε αριθμό τηλεφώνου"
                                    onChange={(e) => handleOnChange(e)}
                                    required={COMPANY_DATA.newCompany.phone}
                                />
                                {showErrors && COMPANY_DATA.newCompany.phone === "" && (
                                    <div className="text-danger">Το πεδίο Αριθμός Τηλεφώνου είναι υποχρεωτικό</div>
                                )}
                            </Col>
                            <Col md={3}>
                                <Input
                                    name={"webpage"}
                                    type={"text"}
                                    label={"Ιστότοπος"}
                                    value={COMPANY_DATA.newCompany.webpage}
                                    autoComplete={"off"}
                                    placeholder={"Εισάγετε Διεύθυνση Ιστοτόπου"}
                                    onChange={(e) => handleOnChange(e)}
                                    required={false}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="text-muted mb-1 mt-1">
                        <i>Στοιχεία Επαφών</i>
                    </div>
                    <EditableTable
                        tableName="Company Contact Points"
                        key={`CCP-${contactPointIncrKey}`}
                        allowActions={true}
                        allowToggleColumns={true}
                        toggleColumns={handleColumnShowHide}
                        columns={tableColumns}
                        data={COMPANY_DATA.newCompany.contactPoints}
                        allowInsertRow={true}
                        enableNewRowCheckbox={true}
                        onUpdate={parentMydataActions}
                    />
                    <Row>
                        <Col sm="12" md="12">
                            <div className="text-muted mb-1 mt-1"><i>Εγκαταστάσεις</i></div>
                            <EditableTable
                                tableName="Company New Installations"
                                key={installationIncrKey}
                                allowActions={true}
                                allowToggleColumns = {false}
                                columns={dynamicColumns}
                                allowInsertRow={true}
                                enableNewRowCheckbox = {true}
                                data={ COMPANY_DATA.newCompany.installations }
                                onUpdate={installationsTableFunctions}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="12" md="12">
                            <div className="text-muted mb-1 mt-1">
                                <i>Χρήστες</i>
                            </div>
                            <EditableTable
                                tableName="New Company Draft Users"
                                key={`draft-users-${COMPANY_DATA.newCompany.users?.length}`}
                                allowActions={true}
                                allowToggleColumns={false}
                                columns={newCompanyUsersDraftColumns}
                                data={COMPANY_DATA.newCompany.users}
                                allowInsertRow={true}
                                enableNewRowCheckbox={true}
                                onUpdate={usersTableFunctions}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <BetterCheckBox
                                name={"autofillAccountantRestApi"}
                                text={"Αυτόματη συμπλήρωση των κωδικών REST API ως κωδικούς λογιστή"}
                                checked={COMPANY_DATA.newCompany.autofillAccountantRestApi}
                                onChange={(e) => handleOnChange(e, "cb", "autofillAccountantRestApi")}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col md={3}>
                            <Button variant="outline-primary" onClick={handleCloseAttempt} disabled={companySaveLoader}>
                                Κλείσιμο
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}>
                            <Button variant="primary" onClick={saveNewCompany} disabled={companySaveLoader}>
                                Αποθήκευση
                            </Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>

            <Modal backdrop={"static"} show={showUsersModal} onHide={handleCloseAttempt} dialogClassName={"modal65PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Δημιουργία Νέου Χρήστη</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="new-client-general product-form position-relative">
                        <Row>
                            <Col sm="12" md="12">
                                <p className="text-muted">
                                    <i>Χρήστες Εταιρείας</i>
                                </p>
                                <EditableTable
                                    tableName="Client Users"
                                    key={userIncrKey}
                                    allowActions={false}
                                    columns={tableUserColumns}
                                    data={companyUsers}
                                    allowInsertRow={false}
                                />
                            </Col>
                        </Row>
                        <hr />
                        <Row>
                            <p className="text-muted">
                                <i>Νέος Χρήστης</i>
                            </p>
                            <Col xs="12" md="4">
                                <div className="mb-2">
                                    <Input
                                        name="firstName"
                                        label="Όνομα"
                                        required={true}
                                        placeholder="Εισάγετε Όνομα"
                                        autoComplete={"off"}
                                        value={COMPANY_DATA.selectedUser.firstName}
                                        onChange={(e) => handleUserChange(e, "default", "firstName")}
                                    />
                                    {COMPANY_DATA.selectedUser.firstName === "" && (
                                        <div className="text-danger">Το Όνομα είναι υποχρεωτικό</div>)}
                                </div>
                            </Col>
                            <Col xs="12" md="4">
                                <div className="mb-2">
                                    <Input
                                        name="lastName"
                                        label="Επώνυμο"
                                        required={true}
                                        placeholder="Εισάγετε Επώνυμο"
                                        autoComplete={"off"}
                                        value={COMPANY_DATA.selectedUser.lastName}
                                        onChange={(e) => handleUserChange(e, "default", "lastName")}
                                    />
                                    {COMPANY_DATA.selectedUser.lastName === "" && (
                                        <div className="text-danger">Το Επώνυμο είναι υποχρεωτικό</div>)}
                                </div>
                            </Col>
                            <Col xs="12" md="4">
                                <div className="mb-2">
                                    <Input
                                        name="email"
                                        placeholder="Εισάγετε Email"
                                        type="email"
                                        label="Email"
                                        required={true}
                                        autoComplete={"off"}
                                        onChange={(e) => handleUserChange(e)}
                                        value={COMPANY_DATA.selectedUser.email}
                                    />
                                    {COMPANY_DATA.selectedUser.email === "" && (
                                        <div className="text-danger">Το Email είναι υποχρεωτικό</div>
                                    )}
                                    {COMPANY_DATA.selectedUser.email !== "" &&
                                        !isValidEmail(COMPANY_DATA.selectedUser.email) && (
                                            <div className="text-danger">Το Email δεν είναι έγκυρο</div>
                                        )}
                                    {COMPANY_DATA.selectedUser.email !== "" &&
                                        isValueAlreadyExists(companyUsers, COMPANY_DATA.selectedUser.email, "email") && (
                                            <div className="text-danger">Το email υπάρχει ήδη</div>
                                        )}
                                </div>
                            </Col>
                        </Row>
                        <Row className={"mt-3 d-flex justify-content-end"}>
                            <Col md={2}>
                                <Button variant="primary" onClick={saveNewUser} disabled={userSaveLoader || !isSaveUserEnabled}>
                                    Αποθήκευση
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal backdrop={"static"} className="themeModal" show={tabCloseWarning}>
                <Modal.Header>
                    <Modal.Title>{t('ClosingTabWarning.warning')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t('ClosingTabWarning.message')}</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => showTabCloseWarning(false)}>{t('ClosingTabWarning.no')}</Button>
                    <Button variant="primary" onClick={() => closeConfirm()}>{t('ClosingTabWarning.yes')}</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={!isEmpty(toDelete)} onHide={() => setToDelete(null)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Διαγραφή εταιρείας</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Είστε σίγουροι ότι θέλετε να διαγράψετε την εταιρεία;
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => onCompanyDelete()} disabled={loadingDelete}>
                        Ναι, διαγραφή {loadingDelete && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default ManageCompanies;